<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Carga masiva | Usuarios | Participantes</h3>
        </div>
    </div>
  </div>
  <hr class="text-dark mb-3">
  <form [formGroup]="formulario" id="formulario">

    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Información del formato</h5>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <label class="form-label">Estado <span class="text-danger">*</span></label>
          <select class="form-control" id='id_estado' formControlName="estado" (change)="municipio_fun($event.target)">
            <option value="" selected>--SELECCIONE ESTADO--</option>
            <option *ngFor="let a of estado;" value="{{a.id_estado}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Municipio <span class="text-danger">*</span></label>
          <select class="form-control" id='id_municipio' formControlName="municipio" (change)="parroquia_fun($event.target)">
            <option *ngFor="let a of municipio;" value="{{a.id}}">{{a.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <label class="form-label">Parroqui <span class="text-danger">*</span></label>
          <select class="form-control" id='id_parroquia' formControlName="parroquia">
            <option *ngFor="let a of parroquia;" value="{{a.id}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Pais <span class="text-danger">*</span></label>
          <select class="form-control" id='id_pais' formControlName="pais">
            <option value="" selected>--SELECCIONE PAIS--</option>
            <option *ngFor="let a of pais;" value="{{a.id_pais}}">{{a.pais_nombre}}</option>
          </select>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-lg btn-primary" (click)="descargar_formato()">Descarga Formato</button>
        </div>
      </div>
    </div>


  </form>


</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
